import styled from 'styled-components';

export const ObjectsSort = styled.div`
	float: left;
	margin-bottom: 24px;

	@media (max-width: 1250px) {
		float: none;
	}

	@media (max-width: 768px) {
		position: relative;
		margin-bottom: 0;
	}
`;

export const ObjectsSortWrap = styled.div`
	display: flex;

	@media (max-width: 768px) {
		flex-direction: column;
		width: 100%;
		top: 100%;
		left: 0;
		background-color: #fff;
		z-index: 10;
		box-sizing: border-box;
	}
`;

export const SortSvg = styled.svg`
	width: 16px;
	height: 16px;
	margin-left: 8px;
	fill: ${({ theme, isActive }) => (isActive ? theme.primaryColor : theme.darkGrayColor)};
`;

export const ObjectsSortItem = styled.button`
	display: flex;
	align-items: center;
	vertical-align: middle;
	color: ${({ theme, isActive }) => (isActive ? theme.primaryColor : theme.darkGrayColor)};
	margin-right: 70px;
	cursor: pointer;
	position: relative;
	background: transparent;
	border: none;
	box-shadow: none;
	${({ theme }) => theme && theme.typography.textMediumS};

	@media (max-width: 768px) {
		align-items: center;
		margin: 0 0 16px;
		position: relative;

		&::before {
			position: absolute;
			top: 4px;
			left: 6px;
		}

		&:last-of-type {
			border-bottom: none;
			margin: 0 0 24px;
		}
	}
`;
